<template>
  <div class="vip-page">
    <div class="bg-decoration">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <main class="vip-main">
      <section class="vip-shell">
        <router-link class="vip-brand-row" to="/" aria-label="返回首页">
          <div class="logo-icon">
            <img :src="logo2Image" alt="" class="logo2-icon" />
          </div>
          <div class="brand-copy">
            <h1 class="brand-name">树苗英语</h1>
            <span class="brand-subtitle">TREE SAPLING</span>
          </div>
        </router-link>

        <header class="vip-header">
          <button type="button" class="vip-back-btn" @click="handleGoBack" aria-label="返回上一页">
            <font-awesome-icon icon="chevron-left" />
          </button>
          <h1 class="vip-title">会员中心</h1>
          <span class="vip-header-spacer" aria-hidden="true"></span>
        </header>

        <section class="vip-hero">
          <div class="vip-hero-copy">
            <p class="vip-hero-kicker">树苗会员</p>
            <h2 class="vip-hero-name">开启孩子的英语成长之旅</h2>
            <ul class="vip-hero-benefits" aria-label="会员权益">
              <li>
                <font-awesome-icon icon="check-circle" />
                <span>10000+ 英文儿歌动画、词卡、绘本、分级课程随心学</span>
              </li>
              <li>
                <font-awesome-icon icon="check-circle" />
                <span>学习进度记录，个性化推荐更高效</span>
              </li>
              <li>
                <font-awesome-icon icon="check-circle" />
                <span>纯净无广告环境，专注学习更放心</span>
              </li>
            </ul>
            <p class="vip-hero-expiry" v-if="userInfo.vipTag">会员有效期至{{ userInfo.vipExpireTime }}</p>
             <p class="vip-hero-expiry" v-if="!userInfo.vipTag && userInfo.vipExpireTime!=null">会员已到期</p>
          </div>

          <div class="vip-hero-visual" aria-hidden="true">
            <span class="vip-sparkle vip-sparkle-1"></span>
            <span class="vip-sparkle vip-sparkle-2"></span>
            <span class="vip-sparkle vip-sparkle-3"></span>
            <div class="vip-crown-card">
              <font-awesome-icon icon="crown" class="vip-crown-icon" />
              <div class="vip-crown-face">
                <span></span>
                <span></span>
                <i></i>
              </div>
            </div>
          </div>
        </section>

        <section class="vip-plan-section">
          <h3 class="vip-plan-heading">选择会员时长</h3>
          <div class="vip-plan-grid">
            <button
              v-for="(plan, index) in plans"
              :key="plan.id"
              type="button"
              class="vip-plan-card"
              :class="{ active: selectedPlan.id === plan.id }"
              @click="selectPlan(index)"
            >
              <span class="vip-plan-name">
                <span v-if="plan.type==1">月卡</span>
                <span v-if="plan.type==2">半年卡</span>
                <span v-if="plan.type==3">年卡</span>
                <span v-if="plan.type==4">永久卡</span>
              </span>
              <span class="vip-plan-price">
                <small>¥</small>
                {{ plan.price }}
              </span>
              <span v-if="plan.recommended" class="vip-plan-badge">推荐</span>
            </button>
          </div>

          <p class="vip-plan-expiry">购买后会员有效期至{{ planExpireTime }}</p>

          <div class="vip-redeem-divider" aria-hidden="true">
            <span></span>
            <em>或</em>
            <span></span>
          </div>

          <div class="vip-redeem-block">
            <label class="vip-redeem-label" for="vip-redeem-code">使用兑换码激活（可选）</label>
            <div class="vip-redeem-row">
              <input
                id="vip-redeem-code"
                v-model.trim="redeemCode"
                type="text"
                class="vip-redeem-input"
                placeholder="请输入兑换码"
                :disabled="isRedeeming"
              />
              <button
                type="button"
                class="vip-redeem-btn"
                :disabled="isRedeeming || !redeemCode.trim()"
                @click="handleRedeemCode"
              >
                {{ isRedeeming ? '激活中' : '激活' }}
              </button>
            </div>
          </div>
        </section>

        <section class="vip-info-card">
          <h3 class="vip-section-title">为什么要买会员?</h3>
          <div class="vip-feature-list">
            <article v-for="feature in features" :key="feature.title" class="vip-feature-item">
              <span class="vip-feature-icon">
                <font-awesome-icon :icon="feature.icon" />
              </span>
              <div class="vip-feature-copy">
                <h4>{{ feature.title }}</h4>
                <p>{{ feature.desc }}</p>
              </div>
            </article>
          </div>
        </section>

        <section class="vip-info-card">
          <h3 class="vip-section-title">购买须知</h3>
          <div class="vip-note-list">
            <article v-for="note in notes" :key="note.title" class="vip-note-item">
              <span class="vip-note-dot"></span>
              <div class="vip-note-copy">
                <h4>{{ note.title }}</h4>
                <p>{{ note.desc }}</p>
              </div>
            </article>
          </div>
        </section>

        <footer class="vip-footer">
          <button type="button" class="vip-pay-btn" @click="openPaymentModal">
            {{ payDesc }}
          </button>
        </footer>
      </section>
    </main>

    <Transition name="modal-fade">
      <div v-if="isPaymentModalOpen" class="vip-payment-mask" @click="closePaymentModal">
        <section class="vip-payment-modal" @click.stop>
          <button
            type="button"
            class="vip-payment-close"
            aria-label="关闭支付弹窗"
            @click="closePaymentModal"
          >
            <font-awesome-icon icon="xmark" />
          </button>

          <header class="vip-payment-header">
            <h3 class="vip-payment-title">选择支付方式</h3>
          </header>

          <div class="vip-payment-summary">
            <p class="vip-payment-amount">¥{{ selectedPlan.price }}</p>
            <p class="vip-payment-desc">树苗会员 - <span v-if="selectedPlan.type==1">月卡</span><span v-if="selectedPlan.type==2">半年卡</span><span v-if="selectedPlan.type==3">年卡</span></p>
          </div>

          <div class="vip-payment-methods">
            <button
              v-for="method in paymentMethods"
              :key="method.id"
              type="button"
              class="vip-payment-method"
              :class="{ active: selectedPaymentMethodId === method.id }"
              @click="selectedPaymentMethodId = method.id"
            >
              <span class="vip-payment-method-main">
                <span
                  class="vip-payment-method-icon"
                  :class="`vip-payment-method-icon-${method.id}`"
                  aria-hidden="true"
                >
                  <font-awesome-icon :icon="method.icon" />
                </span>
                <span class="vip-payment-method-name">{{ method.name }}</span>
              </span>

              <span class="vip-payment-method-check" :class="{ active: selectedPaymentMethodId === method.id }">
                <span v-if="selectedPaymentMethodId === method.id">✓</span>
              </span>
            </button>
          </div>

          <button type="button" class="vip-payment-confirm" :disabled="isPaying" @click="handleConfirmPay">
            {{ isPaying ? '正在发起支付...' : `确认支付 ¥${selectedPlan.price}` }}
          </button>
        </section>
      </div>
    </Transition>

    <Transition name="modal-fade">
      <div v-if="isPaymentResultModalOpen" class="vip-payment-mask" @click="closePaymentResultModal">
        <section class="vip-payment-modal vip-payment-result-modal" @click.stop>
          <button
            type="button"
            class="vip-payment-close"
            aria-label="关闭支付结果弹窗"
            @click="closePaymentResultModal"
          >
            <font-awesome-icon icon="xmark" />
          </button>

          <p class="vip-payment-result-text">充值完成后，根据您的情况点击下面按钮。</p>

          <div class="vip-payment-result-actions">
            <button type="button" class="vip-payment-result-success" @click="handlePaymentSuccess">
              支付成功
            </button>
            <button type="button" class="vip-payment-result-fail" @click="handlePaymentFail">
              支付失败
            </button>
          </div>
        </section>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import logo2Image from '../assets/logo2.png'
import * as UserApi from '@/api/user'
import { getVipPlanList, type VipPlan } from '@/api/vip-plan'
import { createPay } from '@/api/pay'
import { showFailToast, showSuccessToast } from 'vant'

const router = useRouter()

const planExpireTime = ref('')
const payDesc = ref('')

const formatDate = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

const getPlanExpiry = (meta: VipPlan) => {
  if (meta.type==4) return '永久有效'
  let month = 1
  if(meta.type == 2) {
    month = 6
  } else if(meta.type == 3) {
    month = 12
  }
  const expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + (month || 0))
  return formatDate(expiryDate)
}

// const toVipPlanCard = (plan: VipPlan): VipPlanCard => {
//   const meta = planMetaMap[plan.type] || planMetaMap[1]
//   const price = plan.price || meta.fallbackPrice

//   return {
//     ...plan,
//     price,
//     name: meta.name,
//     expiry: getPlanExpiry(meta),
//     duration: meta.duration,
//     cta: `以${price}元续费${meta.ctaDuration}`,
//     badge: plan.recommended ? '推荐' : undefined
//   }
// }

const userInfo = ref({
  vipExpireTime: '',
  vipTag: true
})

const plans = ref<VipPlan[]>()

const paymentMethods = [
  //{ id: 'wechat', name: '微信支付', icon: ['fab', 'weixin'] },
  { id: 'alipay', name: '支付宝', icon: ['fab', 'alipay'] }
]

const features = [
  {
    title: '解锁全站学习内容',
    desc: '10000+集中英文儿歌动画，词卡、动画、分龄课程和后续新内容都可以持续使用。',
    icon: 'book-open'
  },
  {
    title: '成长节奏更连贯',
    desc: '学习记录、打卡进度和推荐内容会围绕孩子当前阶段持续更新。',
    icon: 'seedling'
  },
  {
    title: '更省心的陪学体验',
    desc: '减少频繁切换内容的成本，让家长可以直接进入陪学和复习节奏。',
    icon: 'heart'
  }
]

const notes = [
  {
    title: '会员服务为虚拟内容服务',
    desc: '支付成功后立即开通，立即解锁会员权益，无需兑换，不支持延时开通或未使用时长延期，不支持退款，请确认需求后再购买。'
  },
  {
    title: '会员有效期以支付成功时间开始计算',
    desc: '同一账号下购买新套餐后，会自动顺延或升级现有有效期。'
  },
  {
    title: '权益说明以页面展示为准',
    desc: '若后续上线新会员内容，已开通会员可在有效期内继续使用。'
  },
  {
    title: '如遇支付或账号问题可联系客服',
    desc: '我们会协助核对订单与会员状态，保障正常使用。'
  }
]

const selectedPlan = ref()
const selectedPaymentMethodId = ref('alipay')
const isPaymentModalOpen = ref(false)
const isPaymentResultModalOpen = ref(false)
const isPaying = ref(false)
const redeemCode = ref('')
const isRedeeming = ref(false)

const openPaymentModal = () => {
  isPaymentModalOpen.value = true
}

const closePaymentModal = () => {
  isPaymentModalOpen.value = false
}

const closePaymentResultModal = () => {
  isPaymentResultModalOpen.value = false
}

const getPayHtml = (payResponse: unknown) => {
  if (typeof payResponse === 'string') return payResponse
  if (payResponse && typeof payResponse === 'object') {
    const data = (payResponse as Record<string, unknown>).data
    if (typeof data === 'string') return data
  }
  return ''
}

const submitPayHtml = (payHtml: string, payWindow: Window | null) => {
  const html = payHtml.trim()
  if (!html) return

  if (payWindow && !payWindow.closed) {
    payWindow.document.open()
    payWindow.document.write(html)
    payWindow.document.close()
    return
  }

  const container = document.createElement('div')
  container.style.display = 'none'
  container.innerHTML = html
  document.body.appendChild(container)

  const form = container.querySelector('form')
  if (form instanceof HTMLFormElement) {
    form.submit()
  }
}

const isMobileDevice = () => {
  const userAgent = navigator.userAgent || ''
  const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent)
  const isCoarseSmallScreen = window.matchMedia('(pointer: coarse)').matches && window.matchMedia('(max-width: 768px)').matches

  return isMobileUserAgent || isCoarseSmallScreen
}

const handleConfirmPay = async() => {
  if (isPaying.value || !selectedPlan.value) return
  const isMobile = isMobileDevice()
  const payWindow: Window | null = isMobile ? null : window.open('', '_blank')
  // if (payWindow) {
  //   payWindow.document.write('<p style="font-family: sans-serif; padding: 24px;">正在前往支付...</p>')
  // }
  isPaying.value = true
  try {
    const res = await createPay({payType: selectedPaymentMethodId.value==='wechat'?1:2, planId: selectedPlan.value.id, mobile: isMobile})
    submitPayHtml(getPayHtml(res.body), payWindow)
    closePaymentModal()
    isPaymentResultModalOpen.value = true
  } catch {
    if (payWindow && !payWindow.closed) {
      payWindow.close()
    }
  } finally {
    isPaying.value = false
  }
}

const handlePaymentSuccess = async() => {
  await getUser()
  closePaymentResultModal()
}

const handlePaymentFail = () => {
  closePaymentResultModal()
}

const handleRedeemCode = async() => {
  const code = redeemCode.value.trim()

  if (!code || isRedeeming.value) {
    return
  }

  isRedeeming.value = true
  try {
    await UserApi.activateVip(code)
    showSuccessToast('激活成功')
    redeemCode.value = ''
    await getUser()
  } catch {
    showFailToast('兑换码无效，请检查兑换码')
  } finally {
    isRedeeming.value = false
  }
}

const handleGoBack = () => {
  router.push({
    path: '/',
    query: {
      tab: 'profile'
    }
  })
}

const getUser = async() => {
  try {
    const {vipExpireTime, vipTag} = await UserApi.getUser()
    userInfo.value.vipExpireTime = vipExpireTime
    userInfo.value.vipTag = vipTag
  } catch {
    // 获取用户信息失败时保留默认会员信息
  }
}

const getPlans = async() => {
  try {
    plans.value = await getVipPlanList()
    selectedPlan.value = plans.value[0]
    planExpireTime.value = getPlanExpiry(selectedPlan.value)
    payDesc.value = `以${selectedPlan.value.price}元续费1个月会员`
  } catch {
    // 套餐加载失败时保持当前页面默认状态
  }
}

const selectPlan = (index: number) => {
  selectedPlan.value = plans.value[index]
  planExpireTime.value = getPlanExpiry(selectedPlan.value)
  if(selectedPlan.value.type == 1) {
    payDesc.value = `以${selectedPlan.value.price}元续费1个月会员`
  } else if(selectedPlan.value.type == 2) {
    payDesc.value = `以${selectedPlan.value.price}元续费6个月会员`
  } else if(selectedPlan.value.type == 3) {
    payDesc.value = `以${selectedPlan.value.price}元续费12个月会员`
  } else if(selectedPlan.value.type == 4) {
    payDesc.value = `以${selectedPlan.value.price}元开通永久会员`
  }
}

onMounted(() => {
  getUser()
  getPlans()
})
</script>

<style scoped>
.vip-page {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  background: linear-gradient(135deg, #fdfbf7 0%, #f5f0e8 52%, #faf8f5 100%);
}

.bg-decoration {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.5;
  animation: float-orb 9s ease-in-out infinite;
}

.orb-1 {
  width: 380px;
  height: 380px;
  top: -120px;
  right: -110px;
  background: linear-gradient(135deg, #ffe4d4 0%, #ffd4c4 100%);
}

.orb-2 {
  width: 320px;
  height: 320px;
  bottom: -80px;
  left: -120px;
  background: linear-gradient(135deg, #e8f4ff 0%, #d4e8ff 100%);
  animation-delay: -3s;
}

.orb-3 {
  width: 260px;
  height: 260px;
  top: 36%;
  left: 55%;
  background: linear-gradient(135deg, #ffeaa8 0%, #ffd88a 100%);
  opacity: 0.34;
  animation-delay: -5s;
}

@keyframes float-orb {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  33% {
    transform: translate(26px, -24px) scale(1.05);
  }

  66% {
    transform: translate(-22px, 20px) scale(0.95);
  }
}

.vip-main {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding: 28px 20px 40px;
  display: flex;
  justify-content: center;
}

.vip-shell {
  width: min(100%, 440px);
  padding-bottom: 112px;
}

.vip-shell > * {
  min-width: 0;
}

.vip-brand-row {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-start;
  margin-bottom: 22px;
  width: fit-content;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.vip-brand-row:hover {
  transform: translateY(-1px);
  opacity: 0.92;
}

.vip-brand-row .logo-icon {
  width: 68px;
  height: 68px;
  background: #fff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(140, 104, 68, 0.12);
}

.vip-brand-row .logo2-icon {
  display: block;
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.vip-brand-row .brand-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.vip-brand-row .brand-name {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: #2D3436;
  letter-spacing: 2px;
  line-height: 1.05;
}

.vip-brand-row .brand-subtitle {
  color: #a78b76;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.8px;
  line-height: 1;
}

@media (max-width: 768px),
  (hover: none) and (pointer: coarse) and (orientation: landscape) and (max-height: 540px) {
  .vip-brand-row {
    display: none;
  }
}

@media (min-width: 769px) {
  .vip-brand-row {
    position: absolute;
    top: 8px;
    left: 24px;
    margin-bottom: 0;
    z-index: 2;
  }

  .vip-main {
    padding-top: 104px;
  }
}

.vip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.vip-back-btn {
  width: 44px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.86);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: #6d5b4c;
  font-size: 16px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
  cursor: pointer;
}

.vip-title {
  font-size: 22px;
  font-weight: 800;
  color: #2d3436;
  letter-spacing: 1px;
}

.vip-header-spacer {
  width: 44px;
  height: 44px;
}

.vip-hero {
  position: relative;
  padding: 28px 28px 24px;
  border-radius: 28px;
  background: linear-gradient(135deg, rgba(255, 243, 229, 0.96) 0%, rgba(255, 211, 167, 0.92) 100%);
  border: 1px solid rgba(255, 255, 255, 0.82);
  box-shadow:
    0 22px 48px rgba(196, 143, 98, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.62);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  overflow: hidden;
}

.vip-hero::after {
  content: '';
  position: absolute;
  inset: auto -20px -65px auto;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 70%);
}

.vip-hero-copy {
  position: relative;
  z-index: 1;
}

.vip-hero-kicker {
  color: #9f5f31;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.vip-hero-name {
  margin-top: 8px;
  color: #9a5725;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 900;
}

.vip-hero-benefits {
  display: grid;
  gap: 9px;
  margin-top: 18px;
  padding: 0;
  list-style: none;
}

.vip-hero-benefits li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: rgba(122, 76, 43, 0.86);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.vip-hero-benefits svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #f49a45;
  font-size: 12px;
  filter: drop-shadow(0 2px 4px rgba(212, 113, 32, 0.18));
}

.vip-hero-expiry {
  margin-top: 18px;
  color: rgba(146, 90, 50, 0.72);
  font-size: 13px;
  font-weight: 700;
}

.vip-hero-visual {
  position: relative;
  z-index: 1;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.vip-crown-card {
  position: absolute;
  right: 6px;
  top: 14px;
  width: 92px;
  height: 92px;
  border-radius: 26px;
  background: linear-gradient(180deg, rgba(255, 236, 214, 0.9) 0%, rgba(255, 205, 153, 0.88) 100%);
  box-shadow:
    0 18px 30px rgba(226, 158, 88, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(-8deg);
}

.vip-crown-icon {
  position: absolute;
  inset: 16px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 56px;
  filter: drop-shadow(0 8px 18px rgba(214, 144, 70, 0.18));
}

.vip-crown-face {
  position: relative;
  margin-top: 8px;
  width: 26px;
  height: 18px;
}

.vip-crown-face span {
  position: absolute;
  top: 3px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #d99660;
}

.vip-crown-face span:first-child {
  left: 4px;
}

.vip-crown-face span:last-child {
  right: 4px;
}

.vip-crown-face i {
  position: absolute;
  left: 50%;
  bottom: 2px;
  width: 12px;
  height: 6px;
  border-bottom: 3px solid #d99660;
  border-radius: 0 0 12px 12px;
  transform: translateX(-50%);
}

.vip-sparkle {
  position: absolute;
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.82);
  transform: rotate(45deg);
  border-radius: 2px;
  animation: sparkle 2.2s ease-in-out infinite;
}

.vip-sparkle-1 {
  left: 10px;
  top: 22px;
}

.vip-sparkle-2 {
  left: 28px;
  top: 58px;
  width: 6px;
  height: 6px;
  animation-delay: -0.8s;
}

.vip-sparkle-3 {
  right: 2px;
  bottom: 18px;
  width: 5px;
  height: 5px;
  animation-delay: -1.4s;
}

@keyframes sparkle {
  0%,
  100% {
    opacity: 0.45;
    transform: rotate(45deg) scale(0.8);
  }

  50% {
    opacity: 1;
    transform: rotate(45deg) scale(1.1);
  }
}

.vip-plan-section {
  margin-top: 18px;
}

.vip-plan-heading {
  margin: 0 0 12px;
  color: #2f3032;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.2;
}

.vip-plan-grid {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-left: 0;
  padding-top: 4px;
  padding-right: 24px;
  padding-bottom: 6px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.vip-plan-grid::-webkit-scrollbar {
  display: none;
}

.vip-redeem-divider {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 18px 0 18px;
  color: #958c84;
  font-size: 13px;
  font-weight: 700;
}

.vip-redeem-divider span {
  height: 1px;
  flex: 1;
  background: rgba(160, 145, 130, 0.22);
}

.vip-redeem-divider em {
  font-style: normal;
}

.vip-redeem-block {
  margin-top: 0;
}

.vip-redeem-label {
  display: block;
  color: #2f3032;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.2;
}

.vip-redeem-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 82px;
  gap: 10px;
  margin-top: 14px;
}

.vip-redeem-input {
  min-width: 0;
  height: 48px;
  padding: 0 14px;
  border: 1px solid rgba(216, 193, 168, 0.95);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.76);
  color: #2f3032;
  font-size: 14px;
  font-weight: 700;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.vip-redeem-input::placeholder {
  color: #b5aaa0;
  font-weight: 600;
}

.vip-redeem-input:focus {
  border-color: rgba(255, 138, 61, 0.72);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 0 0 3px rgba(255, 138, 61, 0.12);
}

.vip-redeem-btn {
  height: 48px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #ff9d4f 0%, #ff7626 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 10px 18px rgba(255, 122, 38, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.vip-redeem-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 22px rgba(255, 122, 38, 0.28);
}

.vip-redeem-btn:disabled,
.vip-redeem-input:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.vip-plan-card {
  position: relative;
  flex: 0 0 calc((100% - 24px) / 2.5);
  min-height: 112px;
  padding: 16px 8px 14px;
  border-radius: 18px;
  border: 1px solid rgba(216, 193, 168, 0.95);
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 12px 24px rgba(122, 99, 79, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  scroll-snap-align: start;
  cursor: pointer;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease,
    background 0.25s ease;
}

.vip-plan-card.active {
  background: linear-gradient(180deg, rgba(255, 242, 227, 0.98) 0%, rgba(246, 226, 197, 0.98) 100%);
  border-color: rgba(205, 149, 98, 0.92);
  box-shadow: 0 16px 30px rgba(205, 149, 98, 0.16);
}

.vip-plan-name {
  color: #9f602f;
  font-size: 16px;
  font-weight: 800;
}

.vip-plan-card:not(.active) .vip-plan-name {
  color: #2f3032;
}

.vip-plan-price {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  color: #2a2624;
  font-size: 22px;
  font-weight: 900;
  line-height: 1;
}

.vip-plan-card.active .vip-plan-price {
  color: #b26a37;
}

.vip-plan-price small {
  margin-right: 0;
  font-size: 13px;
  font-weight: 800;
}

.vip-plan-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 3px 7px;
  border-radius: 999px;
  background: rgba(255, 138, 61, 0.12);
  color: #ff8a3d;
  font-size: 10px;
  font-weight: 800;
}

.vip-plan-expiry {
  margin-top: 12px;
  padding-left: 2px;
  color: #9a9896;
  font-size: 13px;
  font-weight: 700;
}

.vip-info-card {
  margin-top: 18px;
  padding: 22px 18px 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.88);
  box-shadow: 0 14px 28px rgba(100, 86, 72, 0.07);
}

.vip-section-title {
  text-align: center;
  color: #16181b;
  font-size: 17px;
  font-weight: 900;
}

.vip-feature-list,
.vip-note-list {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vip-feature-item,
.vip-note-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.vip-feature-icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 138, 61, 0.16) 0%, rgba(255, 205, 153, 0.4) 100%);
  color: #ff8a3d;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.vip-feature-copy h4,
.vip-note-copy h4 {
  margin: 0;
  color: #2d3436;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.35;
}

.vip-feature-copy p,
.vip-note-copy p {
  margin-top: 5px;
  color: #746a62;
  font-size: 13px;
  line-height: 1.6;
}

.vip-note-dot {
  width: 9px;
  height: 9px;
  margin-top: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff9d5b 0%, #ff7f36 100%);
  box-shadow: 0 0 0 5px rgba(255, 138, 61, 0.1);
  flex-shrink: 0;
}

.vip-footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(calc(100% - 40px), 440px);
  padding-top: 20px;
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);
  background: transparent;
  z-index: 30;
}

.vip-pay-btn {
  width: 100%;
  min-height: 56px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3a86e 0%, #e5965b 100%);
  color: #fff7ef;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(229, 150, 91, 0.24);
  cursor: pointer;
}

.vip-pay-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px rgba(229, 150, 91, 0.3);
}

.vip-payment-mask {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(53, 42, 30, 0.28);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.vip-payment-modal {
  position: relative;
  width: min(388px, 100%);
  padding: 24px 24px 28px;
  border-radius: 28px;
  background: linear-gradient(180deg, #fffdfb 0%, #fff8f2 100%);
  box-shadow:
    0 24px 50px rgba(118, 86, 55, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.88);
}

.vip-payment-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #b7aa9d;
  font-size: 22px;
  cursor: pointer;
}

.vip-payment-header {
  padding-right: 36px;
}

.vip-payment-title {
  margin: 0;
  color: #3c322d;
  font-size: 17px;
  font-weight: 800;
}

.vip-payment-summary {
  margin-top: 28px;
  text-align: center;
}

.vip-payment-amount {
  margin: 0;
  color: #2f3035;
  font-size: 26px;
  font-weight: 900;
}

.vip-payment-desc {
  margin-top: 10px;
  color: #9c958f;
  font-size: 14px;
  line-height: 1.4;
}

.vip-payment-methods {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vip-payment-method {
  width: 100%;
  padding: 16px 18px;
  border-radius: 18px;
  border: 1.5px solid #e7ddd3;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.vip-payment-method.active {
  border-color: #ff9d5b;
  background: #fff7ef;
  box-shadow: 0 10px 20px rgba(244, 164, 102, 0.12);
}

.vip-payment-method-main {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.vip-payment-method-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #fff;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.vip-payment-method-icon-wechat {
  background: linear-gradient(135deg, #22c664 0%, #11b755 100%);
}

.vip-payment-method-icon-alipay {
  background: linear-gradient(135deg, #2f8cff 0%, #1d72ff 100%);
}

.vip-payment-method-name {
  color: #38353a;
  font-size: 16px;
  font-weight: 700;
}

.vip-payment-method-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #d7d0c8;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.vip-payment-method-check.active {
  border-color: #ef9b64;
  background: #ef9b64;
}

.vip-payment-confirm {
  width: 100%;
  min-height: 58px;
  margin-top: 28px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3a66a 0%, #eb965a 100%);
  color: #fff8f1;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(235, 150, 90, 0.24);
  cursor: pointer;
}

.vip-payment-confirm:disabled {
  opacity: 0.68;
  cursor: not-allowed;
  box-shadow: none;
}

.vip-payment-result-modal {
  width: min(438px, 100%);
  min-height: 244px;
  padding: 56px 32px 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.vip-payment-result-text {
  margin: 0;
  color: #3c322d;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.6;
  text-align: center;
}

.vip-payment-result-actions {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.vip-payment-result-success,
.vip-payment-result-fail {
  flex: 1;
  min-width: 114px;
  min-height: 50px;
  padding: 0 18px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.vip-payment-result-success {
  border: none;
  background: linear-gradient(135deg, #f3a66a 0%, #eb965a 100%);
  color: #fff8f1;
  box-shadow: 0 14px 28px rgba(235, 150, 90, 0.22);
}

.vip-payment-result-fail {
  border: 1.5px solid #e7ddd3;
  background: rgba(255, 255, 255, 0.9);
  color: #6d5b4c;
}

.vip-payment-result-success:hover,
.vip-payment-result-fail:hover {
  transform: translateY(-1px);
}

.vip-payment-result-fail:hover {
  border-color: #ff9d5b;
  background: #fff7ef;
  box-shadow: 0 10px 20px rgba(244, 164, 102, 0.12);
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@media (hover: hover) and (pointer: fine) {
  .vip-back-btn {
    display: none;
  }
}

@media (min-width: 1024px) {
  .vip-main {
    padding: 120px 32px 56px;
    align-items: flex-start;
  }

  .vip-shell {
    width: min(100%, 1180px);
    padding-bottom: 0;
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) 360px;
    grid-template-areas:
      'header header'
      'hero plans'
      'benefits plans'
      'notes cta';
    gap: 24px 28px;
    align-items: start;
  }

  .vip-header {
    grid-area: header;
    margin-bottom: 0;
    padding: 0 4px;
  }

  .vip-title {
    font-size: 30px;
    letter-spacing: 2px;
  }

  .vip-hero {
    grid-area: hero;
    min-height: 320px;
    padding: 38px 42px 34px;
    gap: 28px;
    align-items: flex-start;
  }

  .vip-hero-copy {
    max-width: 520px;
  }

  .vip-hero-kicker {
    font-size: 17px;
  }

  .vip-hero-name {
    font-size: 40px;
  }

  .vip-hero-benefits {
    gap: 11px;
    margin-top: 20px;
  }

  .vip-hero-benefits li {
    font-size: 14px;
  }

  .vip-hero-benefits svg {
    font-size: 14px;
  }

  .vip-hero-expiry {
    margin-top: 22px;
    font-size: 15px;
  }

  .vip-hero-visual {
    width: 180px;
    height: 180px;
  }

  .vip-crown-card {
    right: 10px;
    top: 20px;
    width: 132px;
    height: 132px;
    border-radius: 34px;
  }

  .vip-crown-icon {
    inset: 22px;
    font-size: 82px;
  }

  .vip-crown-face {
    margin-top: 14px;
    width: 34px;
    height: 22px;
  }

  .vip-crown-face span {
    width: 6px;
    height: 6px;
  }

  .vip-crown-face i {
    width: 14px;
    height: 8px;
  }

  .vip-plan-section {
    grid-area: plans;
    margin-top: 0;
    padding: 24px 22px 18px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.76);
    backdrop-filter: blur(22px);
    -webkit-backdrop-filter: blur(22px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 22px 42px rgba(116, 95, 75, 0.10);
  }

  .vip-plan-heading {
    margin-bottom: 16px;
    font-size: 19px;
  }

  .vip-plan-grid {
    flex-direction: column;
    overflow: visible;
    gap: 14px;
    padding: 0;
  }

  .vip-plan-card {
    flex: none;
    width: 100%;
    min-height: 108px;
    padding: 20px 18px 18px;
    align-items: flex-start;
    text-align: left;
  }

  .vip-plan-price {
    font-size: 26px;
  }

  .vip-plan-expiry {
    margin-top: 16px;
    padding-left: 0;
    font-size: 14px;
  }

  .vip-info-card:nth-of-type(3) {
    grid-area: benefits;
  }

  .vip-info-card:nth-of-type(4) {
    grid-area: notes;
  }

  .vip-info-card {
    margin-top: 0;
    min-height: 100%;
    padding: 26px 24px 24px;
    border-radius: 24px;
  }

  .vip-section-title {
    text-align: left;
    font-size: 20px;
  }

  .vip-feature-list,
  .vip-note-list {
    margin-top: 20px;
    gap: 18px;
  }

  .vip-feature-icon {
    width: 46px;
    height: 46px;
    border-radius: 16px;
    font-size: 18px;
  }

  .vip-feature-copy h4,
  .vip-note-copy h4 {
    font-size: 15px;
  }

  .vip-feature-copy p,
  .vip-note-copy p {
    font-size: 14px;
  }

  .vip-footer {
    grid-area: cta;
    position: static;
    transform: none;
    width: 100%;
    padding: 0;
    margin-top: -6px;
  }

  .vip-pay-btn {
    min-height: 62px;
    font-size: 17px;
    border-radius: 18px;
  }

  .vip-payment-modal {
    width: min(420px, 100%);
    padding: 28px 28px 32px;
  }
}

@media (max-width: 420px) {
  .vip-main {
    padding-left: 14px;
    padding-right: 14px;
  }

  .vip-shell {
    padding-bottom: 108px;
  }

  .vip-footer {
    width: calc(100% - 28px);
  }

  .vip-title {
    font-size: 20px;
  }

  .vip-hero {
    padding: 24px 20px 22px;
  }

  .vip-hero-name {
    font-size: 24px;
  }

  .vip-hero-visual {
    width: 98px;
    height: 98px;
  }

  .vip-crown-card {
    width: 78px;
    height: 78px;
    border-radius: 22px;
  }

  .vip-crown-icon {
    inset: 14px;
    font-size: 48px;
  }

  .vip-plan-grid {
    gap: 8px;
    padding-right: 20px;
  }

  .vip-plan-card {
    flex-basis: calc((100% - 16px) / 2.5);
    min-height: 100px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .vip-plan-name {
    font-size: 15px;
  }

  .vip-plan-price {
    font-size: 20px;
  }

  .vip-payment-mask {
    padding: 14px;
  }

  .vip-payment-modal {
    border-radius: 24px;
    padding: 22px 18px 24px;
  }

  .vip-payment-result-modal {
    min-height: 222px;
    padding: 48px 20px 30px;
  }

  .vip-payment-result-text {
    font-size: 16px;
  }

  .vip-payment-result-actions {
    margin-top: 34px;
    gap: 12px;
  }

  .vip-payment-result-success,
  .vip-payment-result-fail {
    min-width: 104px;
    font-size: 16px;
  }

  .vip-payment-title {
    font-size: 16px;
  }

  .vip-payment-amount {
    font-size: 24px;
  }

  .vip-payment-method {
    padding-left: 14px;
    padding-right: 14px;
  }
}

@media (max-width: 768px),
  (min-width: 769px) and (max-width: 1024px) and (orientation: portrait),
  (hover: none) and (pointer: coarse) and (orientation: landscape) and (max-height: 540px) {
  .orb,
  .vip-bg-orb {
    display: none;
  }

  .vip-card,
  .vip-payment-modal,
  .vip-payment-result-modal,
  .vip-payment-mask {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  .vip-sparkle {
    animation: none;
  }

  .vip-plan-card,
  .vip-payment-method,
  .vip-payment-result-success,
  .vip-payment-result-fail {
    transition-property: background-color, color, border-color, box-shadow, transform, opacity;
  }
}
</style>
